import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyDCScriptMigrationPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DCScriptMigrationPage" */ './DCScriptMigrationPage.tsx'
			)
		).DCScriptMigrationPage,
});
